// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__2A4Kv","messageTitle":"styles_messageTitle__HrcpE","messageText":"styles_messageText__alwvt"};